// extracted by mini-css-extract-plugin
export default {"s_card_container":"common_s_card_container__Gjdtq","header":"common_header__5+WOk","discription":"common_discription__z+k9d"};